import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class PureDialogBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.icon = '';
    switch (this.props.type) {
      case 'success':
        this.icon = 'check_circle';
        break;
      case 'error':
        this.icon = 'cancel';
        break;
      case 'warning':
        this.icon = 'report_problem';
        break;
      default:
        this.icon = 'info';
        break;
    }
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  render() {
    const { t } = this.props;
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          // toggle={this.toggle}
          className={this.props.className}
          fade={false}
        >
          <ModalHeader
          // toggle={this.toggle}
          // charcode="X"
          >
            <i className="md-icon" style={{ marginRight: 10 }}>
              {this.icon}
            </i>
            <span style={{ verticalAlign: 'text-bottom' }}>
              {t(this.props.title)}
            </span>
          </ModalHeader>
          <ModalBody>{t(this.props.body)}</ModalBody>
          <ModalFooter>
            {this.props.onCancel ? (
              <Button color="default" onClick={this.props.onCancel}>
                {t('Cancel')}
              </Button>
            ) : null}
            <Button color="primary" onClick={this.props.onYes}>
              {t('Yes')}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export const DialogBox = withTranslation('app')(PureDialogBox);
